/** @jsxImportSource @emotion/react */

import { ReactComponent as DepositIcon } from "assets/common/icons/deposit.svg";
import { ReactComponent as WithdrawIcon } from "assets/common/icons/withdraw.svg";
import { PATH } from "constants/path";
import { NavLink } from "react-router-dom";

import { MenuPaymentStyle } from "./index.style";

const MenuPayment = () => {
  return (
    <div css={MenuPaymentStyle.self}>
      <NavLink to={PATH.User.Deposit} css={MenuPaymentStyle.menuItem}>
        <DepositIcon />
        Nạp tiền
      </NavLink>
      <NavLink to={PATH.User.Withdraw} css={MenuPaymentStyle.menuItem}>
        <WithdrawIcon />
        Rút tiền
      </NavLink>
    </div>
  );
};

export default MenuPayment;
